/**
 * Query keys del dominio Órdenes, segmentadas por sede activa.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos):
 * `['orders', { sede, ... }]`. Incluir la sede en la key **cachea por sede**: al
 * cambiar de sede, los listados/detalle se recargan (clave distinta) en vez de
 * mostrar los de la sede anterior. La sede activa la inyecta `lib/api` como
 * `X-Sede-Id`; aquí solo entra en la key para segmentar el cache.
 */
import type { OrdersQuery } from "../types";

/** Raíz de todas las queries de órdenes (para invalidación amplia). */
export const ORDERS_ROOT_KEY = ["orders"] as const;

/** Key del listado paginado, segmentada por sede + filtros. */
export function ordersListQueryKey(sedeId: number | null, query: OrdersQuery) {
  return [
    "orders",
    "list",
    {
      sede: sedeId,
      status: query.status,
      search: query.search,
      page: query.page,
      per_page: query.per_page,
    },
  ] as const;
}

/** Key del detalle de una orden, segmentada por sede. */
export function orderDetailQueryKey(sedeId: number | null, id: number) {
  return ["orders", "detail", { sede: sedeId, id }] as const;
}
